<section global-hero [heroData]="heroData"></section>
<section
  jump-to
  [jumpToData]="jumpToData"
  [activeSection]="jumpToData[0].buttonFragment"
></section>
<section why-screen></section>
<section cards></section>
<!-- video section here -->
<section t1d-stories id="t1d-stories"></section>
<section findings></section>
<section facts></section>
<section accordion></section>
<section cta-bottom [data]="ctaBottomData"></section>
<review-bar [isUpdated]="true" dateText="in August 2026"></review-bar>
